$(document).ready(function () {
	
	if ($('#avisoLegalCookies').length){
		var pCookie = 'p1='+'1469177373613';
		document.cookie=pCookie;
		
		function ie_ver(){  
		    var iev=0;
		    var ieold = (/MSIE (\d+\.\d+);/.test(navigator.userAgent));
		    var trident = !!navigator.userAgent.match(/Trident\/7.0/);
		    var rv=navigator.userAgent.indexOf("rv:11.0");

		    if (ieold) iev=new Number(RegExp.$1);
		    if (navigator.appVersion.indexOf("MSIE 10") != -1) iev=10;
		    if (trident&&rv!=-1) iev=11;
		    return iev;         
		}
		
		if(ie_ver()==0){//si es 0 es que no es IE11
			if(!getCookie("avisoLegalCookies")){
				setCookie("avisoLegalCookies",new Date(),30,"/");
			}
		} else{//es ie 11
			if(!GetCookieIE("avisoLegalCookies")){
				SetCookieIE("avisoLegalCookies","avisoLegalCookies");
			}
		}

		function getCookie(cookieName){
			var name = cookieName + "=";
			var ca = document.cookie.split(';');
			for(var i=0; i<ca.length; i++){
			  	var c = ca[i].trim();
			  	if (c.indexOf(name)==0) 
				  	return true;
		  	}
			return false;
		}
		
		function setCookie(cookieName,cookieValue,nDays,ruta) {
			 var today = new Date();
			 var expire = new Date();
			 if (nDays==null || nDays==0) nDays=1;
			 expire.setTime(today.getTime() + 3600000*24*nDays);
			 document.cookie = cookieName+"="+escape(cookieValue)+ ";expires="+expire.toGMTString()+";path="+ruta;
		}
		
		function SetCookieIE(sName, sValue){
			document.cookie = sName + "=" + escape(sValue);
			// Expires the cookie in one month
			var date = new Date();
			date.setMonth(date.getMonth()+1);
			document.cookie += ("; expires=" + date.toUTCString()); 
		}
			
		function GetCookieIE(sName){
			// cookies are separated by semicolons
			var aCookie = document.cookie.split("; ");
			for (var i=0; i < aCookie.length; i++){
				// a name/value pair (a crumb) is separated by an equal sign
			    var aCrumb = aCookie[i].split("=");
			    if (aCrumb[0].indexOf(sName)!=-1) 
			    return true;
			}
			// a cookie with the requested name does not exist
			return false;
		}

		if($("#avisoLegalCookies").length && $("#avisoLegalCookies").hasClass("visible")){
			setTimeout(function() {
				ocultaAviso();
			} , 30000);
		}


	}
});

function ocultaAviso(){
	$("#avisoLegalCookies").fadeOut("slow");
}

window.ocultaAviso = ocultaAviso;
